/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ServiceAreaPreferencesServiceProfileServiceProfileType =
  (typeof ServiceAreaPreferencesServiceProfileServiceProfileType)[keyof typeof ServiceAreaPreferencesServiceProfileServiceProfileType];

export const ServiceAreaPreferencesServiceProfileServiceProfileType = {
  traveling: 'traveling',
} as const;
